import { EventCriteria, KibsiEvent, KibsiEventDetailed, MediaMetadata } from '@kibsi/ks-event-types'
import { AxiosRequestConfig } from 'axios'
import { PaginationRequest, PaginationResponse } from 'types/pagination'
import { KibsiClient } from './base'
import { KibsiClientParams } from './params'

export class EventKibsiClient extends KibsiClient {
    constructor(params: KibsiClientParams) {
        super(params, 'event')
    }

    listEvents(
        paginationRequest?: PaginationRequest<EventCriteria>,
        requestConfig?: AxiosRequestConfig,
    ): Promise<PaginationResponse<KibsiEvent>> {
        const { continuationToken, pageSize, sort, criteria = {} } = paginationRequest || {}
        const {
            active,
            deploymentId,
            applicationId,
            siteId,
            itemType,
            itemTypes,
            startDateTime,
            endDateTime,
            dataCollection,
            startState,
        } = criteria
        const request: AxiosRequestConfig = requestConfig ? { ...requestConfig } : {}

        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        request.params = {
            ...requestConfig?.params,
            continuationToken,
            pageSize,
            sort,
            deploymentId,
            active,
            applicationId,
            siteId,
            itemType,
            itemTypes: itemTypes?.join(','),
            startDateTime,
            endDateTime,
            dataCollection,
        }

        for (const [key, value] of Object.entries(startState ?? {})) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            request.params[`start.${key}`] = value
        }

        return this.get('/events', request)
    }

    getEvent(deploymentId: string, eventId: string, requestConfig?: AxiosRequestConfig): Promise<KibsiEventDetailed> {
        return this.get(`events/${deploymentId}/${eventId}`, requestConfig)
    }

    getEventMediaMetadata(
        deploymentId: string,
        eventId: string,
        requestConfig?: AxiosRequestConfig,
    ): Promise<MediaMetadata[]> {
        return this.get(`events/${deploymentId}/${eventId}/media`, requestConfig)
    }

    getMediaDownload(mediaId: string, requestConfig?: AxiosRequestConfig): Promise<Blob> {
        return this.get(`media/${mediaId}/download`, { ...requestConfig, responseType: 'blob' })
    }

    setEventFlagged(
        deploymentId: string,
        eventId: string,
        flagged: boolean,
        requestConfig?: AxiosRequestConfig,
    ): Promise<void> {
        return this.put(`events/${deploymentId}/${eventId}/flag`, { flagged }, requestConfig)
    }

    getEventCounts(
        deploymentId: string,
        eventId: string,
        requestConfig?: AxiosRequestConfig,
    ): Promise<Record<string, number>> {
        return this.get(`events/${deploymentId}/${eventId}/counts`, requestConfig)
    }
}
